import { render } from "./SVGDrawer.vue?vue&type=template&id=66482e9e"
import script from "./SVGDrawer.vue?vue&type=script&lang=js"
export * from "./SVGDrawer.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__